import {
    VEHICLE_CHECKLIST_GET_REPORT,
    VEHICLE_CHECKLIST_EDIT_REPORT
} from "./types";
import firebase from "firebase/app";

export const getReport = (subjectName, uid, timestamp) => {
    return dispatch => {
        dispatch({
            type: VEHICLE_CHECKLIST_GET_REPORT.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VEHICLE_CHECKLIST_GET_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${uid}/reports/vehicle_checklist/${timestamp}`
                        )
                        .on("value", snapshot => {
                            dispatch({
                                type: VEHICLE_CHECKLIST_GET_REPORT.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VEHICLE_CHECKLIST_GET_REPORT.FAIL
            });
        }
    };
};
export const submitReport = (report, path) => {
    const pathVars = path.split("/");
    const subjectName = pathVars[2].replace(/-/g, "_");
    const uid = pathVars[3];
    const timestamp = pathVars[5].replace(/_/g, " ").replace(/\./g, ":");
    return dispatch => {
        dispatch({
            type: VEHICLE_CHECKLIST_EDIT_REPORT.REQUEST
        });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VEHICLE_CHECKLIST_EDIT_REPORT.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref(
                            `/subjects/${subjectName}/${uid}/reports/vehicle_checklist/${timestamp}`
                        )
                        .update(report, snapshot => {
                            dispatch({
                                type: VEHICLE_CHECKLIST_EDIT_REPORT.SUCCESS
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VEHICLE_CHECKLIST_EDIT_REPORT.FAIL
            });
        }
    };
};
